// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SinglePageView__SinglePageView___fdDFC{align-items:center;display:block;height:100%;justify-content:center;min-width:100%;overflow:auto;position:relative;scroll-snap-align:start;width:100vw}", ""]);
// Exports
exports.locals = {
	"SinglePageView": "SinglePageView__SinglePageView___fdDFC"
};
module.exports = exports;
